import PropTypes from '@root/vendor/prop-types';
import React, { Component } from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import Shadows from '@root/brand/src/utils/shadows';
import closeModal from '@root/core/src/assets/closeModal.svg';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { opacityKeyframes } from '@root/brand/src/utils/animation';

export default class QuotesSelectedModal extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    closeImage: PropTypes.node,
    isOverlay: PropTypes.bool,
    onCloseClick: PropTypes.func,
    styles: PropTypes.object,
  }

  _getWrapperStyles() {
    return this.props.isOverlay ? styles.wrapperOverlay : styles.wrapperRegular;
  }

  _getModalStyles() {
    return this.props.isOverlay ? styles.modalOverlay : styles.modalRegular;
  }

  render() {
    return (
      <div
        css={[
          styles.wrapper,
          this._getWrapperStyles(),
        ]}
      >
        <div
          css={[
            this._getModalStyles(),
            styles.modal,
            this.props.styles,
          ]}
        >
          {this.props.onCloseClick && (
            <button
              aria-label={'close'}
              css={[
                styles.closeButton,
              ]}
              onClick={this.props.onCloseClick}
            >
              <img src={this.props.closeImage || closeModal} />
            </button>
          )}
          {this.props.children}
        </div>
      </div>
    );
  }
}

const sharedStyles = {
  modal: {
    padding: '50px 110px',
    borderRadius: 10,
    maxWidth: 'calc(41.66666667% + 220px)',
    ...Shadows.modal(),
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
};

const styles = StyleSheet.create({
  closeButton: {
    background: 'transparent',
    border: 0,
    cursor: 'pointer',
    height: 24,
    padding: 0,
    position: 'absolute',
    right: 20,
    top: 20,
    width: 24,
  },
  modal: {
    position: 'relative',
    backgroundColor: Colors.white(),
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  modalRegular: {
    ...Responsive.md({
      ...sharedStyles.modal,
    }),
    paddingTop: 50,
  },
  modalOverlay: {
    ...sharedStyles.modal,
  },
  wrapper: {
    animationName: opacityKeyframes,
    animationDuration: '300ms',
  },
  wrapperOverlay: {
    ...sharedStyles.wrapper,
  },
  wrapperRegular: {
    ...Responsive.md({
      ...sharedStyles.wrapper,
    }),
  },
});
